import Vue from "vue";
import ClickOutside from 'vue-click-outside'
import Glide from "@glidejs/glide";
Vue.prototype.$eventHub = new Vue();

if (document.getElementById("vue-header")) {
  new Vue({
    el: "#vue-header",
    directives: {
      ClickOutside
    },
    data() {
      return {
        isMenuOpen: false,
        ww: window.innerWidth,
      };
    },
    mounted() {
      window.addEventListener("scroll", (e) => {
        this.scrollPos = window.scrollY;
      });
      window.addEventListener("resize", (e) => {
        this.ww = window.innerWidth;
      });
    },
    computed: {
      toggleClasses() {
        return {
          "is-open h-full w-full md:w-72": this.isMenuOpen,
          "is-closed h-logo w-18": !this.isMenuOpen,
        };
      },
      toggleClassesMenu() {
        return {
          "left-0": this.isMenuOpen,
          "-left-96": !this.isMenuOpen,
        };
      },
    },
    methods: {
      toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
        document.body.classList.toggle("overflow-hidden");
      },
      close() {
        this.isMenuOpen = false
        document.body.classList.remove("overflow-hidden");
      }
    },
  });
}
